import { useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import { Button, Stack, Typography } from "@mui/material";
import { DeleteAccountDialog } from "./DeleteAccountDialog";
import { useDeleteAccount } from "./useDeleteAccount";

/** "Delete account" for the Accounts & Billing modal (#3824). Copy is from the issue. */
export const DeleteAccountSection = ({ contactUrl }: { contactUrl: string }) => {
  const [open, setOpen] = useState(false);
  const { deleteAccount, loading, error, blocked } = useDeleteAccount();

  const handleConfirm = async () => {
    await deleteAccount();
    // An issued ID token outlives the server-side disable; the hard reload also
    // drops every Zustand store holding their data.
    await signOut(getAuth()).catch(() => {});
    window.location.href = "/";
  };

  return (
    <Stack direction="column" spacing={1}>
      <Typography sx={{ fontWeight: "700" }}>Delete Account</Typography>
      <Stack direction="column" spacing={1} alignItems="flex-start">
        <Button
          variant="outlined"
          color="error"
          onClick={() => setOpen(true)}
          data-testid="open-delete-account"
        >
          Delete account
        </Button>
        <Typography variant="body2" color="text.secondary">
          By deleting your account, you’ll no longer be able to access any of
          your designs or log in to Mattoboard.
        </Typography>
      </Stack>

      <DeleteAccountDialog
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
        loading={loading}
        error={error}
        blocked={blocked}
        contactUrl={contactUrl}
      />
    </Stack>
  );
};
